/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";

import BrandIcon from "./BrandIcon";
import Button from "../elements/Button";

export default function Footer() {
  return (
    <div className="bg-gray-50 border-t border-gray-200 pb-6">
      <div className="container flex-col mx-auto ">
        <div className="flex flex-col sm:flex-row mt-8 justify-center">
          <div className="w-1/3 flex-col ml-16 mr-8">
            <BrandIcon />
            <p className="w-full text-lg text-gray-600 font-light">
              Where Talent Meets Opportunity <br />
              Perfectly !
            </p>
          </div>
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <h1 className="text-lg text-black pt-4 pb-2">Office</h1>
            <p className="text-lg text-gray-600 font-light">
              Letmecastu@gmail.com Isthereabhishek@gmail.com
            </p>
            <p className="text-lg text-gray-600 font-light">Dehradun</p>
          </div>
          <div className="w-1/3 ml-16 sm:ml-0 mt-0">
            <h1 className="text-lg text-black pt-4 pb-2">Socials</h1>
            <Button
              href="https://www.instagram.com/abhishek_can?igsh=cWp0amhncjUwaHNm"
              type="link"
              target="_blank"
              className="flex text-lg text-gray-600 font-light hover:underline"
              isExternal
            >
              Instagram
            </Button>
            <Button
              href="https://www.linkedin.com/in/letmecast-and-production-co-3b6371352/"
              type="link"
              target="_blank"
              className="flex text-lg text-gray-600 font-light hover:underline"
              isExternal
            >
              LinkedIn
            </Button>
            <Button
              href="https://x.com/letmecastu?s=11"
              type="link"
              target="_blank"
              className="flex text-lg text-gray-600 font-light hover:underline"
              isExternal
            >
              X
            </Button>
          </div>
        </div>
        <div className="flex-col text-center mt-7">
          <p className="text-lg text-gray-400 font-light">
            Copyright 2025 - All rights reserved - ApoorvThaledi
          </p>
          <div className="flex-row">
            <p className="inline-block text-lg text-gray-400 font-light">
              {/* Made with &#x2764; by&nbsp; */}
            </p>
            <Button
              href="https://github.com/racmathafidz"
              type="link"
              target="_blank"
              className="text-lg text-theme-purple font-light"
              isExternal
            >
              {/* Racmat Hafidz Fadli */}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
